<template>
  <section class="contacts">
    <Hero />
    <List />
  </section>
</template>

<script>
import { useHead } from "@vueuse/head";
import { defineComponent, computed, reactive } from "vue";
import Hero from "@/components/views/contacts/hero.vue";
import List from "@/components/views/contacts/list.vue";

export default defineComponent({
  setup() {
    const siteData = reactive({
      title: "Contacts | Zoinix Inter Technology",
      url: "https://zoinix.com/contacts",
    });

    useHead({
      title: computed(() => siteData.title),
      meta: [
        {
          name: "og:title",
          content: computed(() => siteData.title),
        },
        {
          name: "tw:title",
          content: computed(() => siteData.title),
        },
        {
          name: "og:url",
          content: computed(() => siteData.url),
        },
        {
          name: "twitter:url",
          content: computed(() => siteData.url),
        },
      ],
    });
  },
  components: { Hero, List },
});
</script>
